import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setConstructionPage } from '../redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useConstructionSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getConstructionSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website.construction_page.construction_section}`);
      console.log("🚀 ~ getConstructionSectionJson ~ data:", response);
      console.log("🚀 ~ getConstructionSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setConstructionPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Construction section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getConstructionSectionJson();
  }, [getConstructionSectionJson]);

  return {
    data,
    loading,
    error,
    getConstructionSectionJson,
    fetchOnMount,
    refetch: getConstructionSectionJson
  };
};

export default useConstructionSection;
